import Vue from 'vue';
import Vuex from 'vuex';
import report from './modules/report';
import auth from './modules/auth';
import checkout from './modules/checkout';
import discount from './modules/discount';
import outlet from './modules/outlet';
import shifts from './modules/shifts';
import tag from './modules/tag';
import tax from './modules/tax';
import payment from './modules/payment';
import product from './modules/product';
import transaction from './modules/transaction';
import modifierSet from './modules/modifierSet';
import reportProduct from './modules/report-product';
import drawerSession from './modules/drawer-session';
import category from './modules/category';
import centralSettings from './modules/central-settings';
import variant from './modules/variant';
import central from './modules/central';
import stockCost from './modules/inventory-stock-cost';
import stockMovement from './modules/inventory-stock-movement';
import timezone from './modules/timezone';
import state from './modules/state';
import categoryBusiness from './modules/categoryBusiness';
import currency from './modules/currency';
import inventoryStock from './modules/inventory-stock';
import inventorySync from './modules/inventory-sync';
import inventoryStockReceive from './modules/inventory-stock-receive';
import inventoryStockCheck from './modules/inventory-stock-check';
import inventoryStockReturn from './modules/inventory-stock-return';

import { createVuexLoader } from 'vuex-loading';

const VuexLoading = createVuexLoader({
    moduleName: 'loading',
    componentName: 'v-loading',
    className: 'v-loading',
});

Vue.use(Vuex);
Vue.use(VuexLoading);

export default new Vuex.Store({
    plugins: [VuexLoading.Store],
    modules: {
        report,
        auth,
        checkout,
        discount,
        outlet,
        shifts,
        modifierSet,
        tag,
        payment,
        product,
        tax,
        transaction,
        reportProduct,
        drawerSession,
        category,
        centralSettings,
        variant,
        central,
        stockCost,
        stockMovement,
        timezone,
        state,
        categoryBusiness,
        currency,
        inventoryStock,
        inventorySync,
        inventoryStockReceive,
        inventoryStockCheck,
        inventoryStockReturn,
    },
});



// WEBPACK FOOTER //
// ./resources/assets/js/store/index.js